"use client";
import React, { useState } from "react";

const InsightsPrice = () => {
  const [yearFilterBtnSelection, setYearFilterBtnSelection] = useState("6 M");

  const handleYearFilterClick = (year) => {
    setYearFilterBtnSelection(year);
  };
  return (
    <div className="border border-solid border-[#E0E0E0] p-4 gap-4 w-[393px] h-[434px] rounded-lg">
      <p className="font-semibold text-base text-[#333333]">
        Stock Price of Simulation
      </p>
      <img src="/images/monteSimulation.png" alt="" className="" />
      <p className="font-medium text-[8px] text-[#DBA12C]">
        Note: This graph is derived from Monte Carlo simulation
      </p>
      <div className="flex justify-center">
        <div className="flex w-max  border border-[#C3D5DC] items-center  gap-4  mb-2 mt-4 rounded-full">
          <button
            onClick={() => handleYearFilterClick("6 M")}
            className={`text-xs font-bold pl-3 py-2 text-[#333333] ${
              yearFilterBtnSelection === "6 M"
                ? "bg-[#C3D5DC] rounded-full pr-3 pl-3 py-2"
                : ""
            }`}
          >
            6 M
          </button>
          <button
            className={`text-xs font-bold pl-1 py-2 pr-3 text-[#333333] ${
              yearFilterBtnSelection === "1 Y"
                ? "bg-[#C3D5DC] rounded-full pr-3 pl-3 py-2"
                : ""
            }`}
            onClick={() => handleYearFilterClick("1 Y")}
          >
            1 Y
          </button>
          <button
            className={`text-xs font-bold pl-1 py-2 pr-3 text-[#333333] ${
              yearFilterBtnSelection === "3 Y"
                ? "bg-[#C3D5DC] rounded-full pr-3 pl-3 py-2"
                : ""
            }`}
            onClick={() => handleYearFilterClick("3 Y")}
          >
            3 Y
          </button>
        </div>
      </div>
      {yearFilterBtnSelection === "6 M" ? (
        <>
          <div className="flex justify-between">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">10%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">43.89</p>
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">25%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">23.79</p>
            </div>
          </div>{" "}
          <div className="flex justify-between mt-4">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">50%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">5.89</p>
            </div>
          </div>
        </>
      ) : yearFilterBtnSelection === "1 Y" ? (
        <>
          <div className="flex justify-between">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">14%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">43.89</p>
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">25%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">23.79</p>
            </div>
          </div>{" "}
          <div className="flex justify-between mt-4">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">50%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">5.89</p>
            </div>
          </div>
        </>
      ) : yearFilterBtnSelection === "3 Y" ? (
        <>
          <div className="flex justify-between">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">10%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">43.89</p>
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">25%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">23.79</p>
            </div>
          </div>{" "}
          <div className="flex justify-between mt-4">
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Expected Return
              </p>
              <p className="text-xs font-bold text-[#333333]">50%</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-[#8B8B8B]">
                Probability
              </p>
              <p className="text-xs font-bold text-[#333333]">5.89</p>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default InsightsPrice;
